(() => {
  'use strict';
  if (window.VGQuoteJourney) return;
  const key = 'vg_quote_journey_v1';
  const script = document.currentScript;
  const retention = 90 * 86400;
  let journey = null;
  let captured = false;
  const now = () => Math.floor(Date.now() / 1000);
  const permitted = () => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true;
    } catch (_) { return false; }
  };
  const text = (value, max, pattern) => typeof value === 'string' && value.length <= max && pattern.test(value) ? value : '';
  const clear = () => {
    journey = null;
    captured = false;
    try { localStorage.removeItem(key); } catch (_) {}
  };
  const fill = () => {
    const input = document.querySelector('#vg-quote-request-form input[name="website_journey"]');
    if (input) input.value = permitted() && journey ? JSON.stringify(journey) : '';
  };
  const capture = () => {
    try {
      if (!permitted()) { clear(); fill(); return; }
      if (captured) { fill(); return; }
      captured = true;
      const time = now();
      const url = new URL(window.location.href);
      let host = '';
      if (document.referrer) {
        try { host = new URL(document.referrer).hostname.toLowerCase(); } catch (_) { host = 'invalid-referrer'; }
      }
      let old = null;
      try { old = JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) {}
      if (!old || old.schema_version !== 1 || old.capture_method !== 'first_party_website'
          || old.consent?.analytics !== true || old.consent?.marketing !== true
          || !Number.isInteger(old.first_touch?.at) || old.first_touch.at < time - retention
          || old.first_touch.at > time || !Number.isInteger(old.last_touch?.at)
          || old.last_touch.at > time || old.first_touch.at > old.last_touch.at) old = null;
      const touch = { at: time };
      for (const name of ['utm_source', 'utm_medium', 'utm_campaign']) {
        touch[name] = text(url.searchParams.get(name) || '', 120, /^[a-zA-Z0-9_. +:/-]*$/);
      }
      for (const name of ['gclid', 'gbraid', 'wbraid']) {
        touch[name] = text(url.searchParams.get(name) || '', 250, /^[a-zA-Z0-9_-]*$/);
      }
      touch.campaign_id = text(url.searchParams.get('campaign_id') || url.searchParams.get('utm_id') || url.searchParams.get('gad_campaignid') || '', 30, /^[0-9]*$/);
      touch.landing_path = text(url.pathname, 240, /^(?:\/|\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products|collections)\/[a-zA-Z0-9_-]+)$/);
      touch.product_id = text(script?.dataset.vgProductId || '', 30, /^[0-9]*$/);
      touch.referrer_host = text(host, 200, /^[a-z0-9.-]*$/);
      const queryKeys = ['utm_source','utm_medium','utm_campaign','gclid','gbraid','wbraid','campaign_id','utm_id','gad_campaignid'];
      const tagged = queryKeys.some(name => url.searchParams.has(name));
      touch.unresolved_tags = queryKeys.some(name => url.searchParams.has(name) && !(touch[name] || (['utm_id','gad_campaignid'].includes(name) && touch.campaign_id)));
      const internal = host === url.hostname.toLowerCase();
      const direct = !tagged && host === '';
      if (!old && internal && !tagged) { journey = null; fill(); return; }
      if (!old || tagged || (!internal && host !== '') || (!internal && time - old.last_touch.at > 1800)) {
        journey = {
          schema_version: 1,
          capture_method: 'first_party_website',
          consent: { analytics: true, marketing: true },
          first_touch: old?.first_touch || touch,
          last_touch: touch,
          last_non_direct: direct ? old?.last_non_direct || null : touch
        };
      } else { journey = old; }
      try { localStorage.setItem(key, JSON.stringify(journey)); } catch (_) {}
      fill();
    } catch (_) { journey = null; fill(); }
  };
  window.VGQuoteJourney = { export: () => {
    if (!permitted()) { clear(); return ''; }
    return journey ? JSON.stringify(journey) : '';
  } };
  document.addEventListener('visitorConsentCollected', capture);
  document.addEventListener('submit', event => {
    if (event.target?.id === 'vg-quote-request-form') { capture(); fill(); }
  }, true);
  const start = () => {
    if (window.Shopify?.customerPrivacy) { capture(); return; }
    if (typeof window.Shopify?.loadFeatures === 'function') {
      try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) capture(); }); } catch (_) {}
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
